
export default {
  props: {
    formId: {
      type: Number,
      required: true,
    },
    darkBg: {
      type: Boolean,
    },
    buttonCentered: {
      type: Boolean,
    },
  },
  data: () => ({
    form: {},
    formFields: [],
    loading: false,
    requiredCheckboxes: [],
    originalFields: [],
  }),
  async created() {
    const {data} = await this.$axios.get(`/forms/${this.formId}`);
    const template = data.data;

    template.fields.forEach((field) => {
      if (field.type === 'checkbox') {
        this.form[field.name] = [];
        if (field.required) {
          this.requiredCheckboxes.push(field.name);
        }
      } else {
        this.form[field.name] = null;
      }
    });

    this.formFields = template.fields;
    this.originalFields = template.fields;
  },
  methods: {
    async submit() {
      this.loading = true;
      try {
        Object.keys(this.form).forEach((name) => {
          if (this.requiredCheckboxes.includes(name)) {
            this.form[name] = [this.form[name]];
          }
        });

        await this.$axios.post('/forms/' + this.formId, this.form);
        this.$formulate.reset(`dynamic-form-${this.formId}`);
        if (this.$listeners['event:success']) {
          this.$emit('event:success');
        } else {
          this.$toast.success(this.$t('Form has been submitted.'));
        }
      } catch (e) {
        console.error(e);

        if (this.$listeners['event:error']) {
          this.$emit('event:error');
        } else {
          this.$toast.error(this.$t('Something went wrong while submitting the form. Try again later.'));
        }
      }
      this.loading = false;
    },
  },
};
